<template>
    <div class="footer-bar">
        <div class="select-all-btn">
            <!-- <van-checkbox :value="checkAll" checked-color="#005423" @click="onChange" icon-size="16px"> -->
            <van-checkbox :value="checkAll" checked-color="#005423" @click="onChange" icon-size="0.43rem">
                全选
            </van-checkbox>
        </div>

        <div class="summary">
            <span>合计：</span>
            <span class="red-money">{{money | formatPrice}}</span>
        </div>

        <mobile-button class="operate-btn__fee" color="#ab2c31" @click="onSubmit">
            去交费
        </mobile-button>
    </div>
</template>

<script>
    import log from 'utils/log'
    import MobileButton from "components/mobile-button/index";

    export default {
        name: "submit-bar",
        components: {MobileButton},
        props: {
            model: Object,
            money: Number,
            checkAll: Boolean,
        },

        data() {
            return {
                checked: false,
            }
        },
        methods: {
            onSubmit() {
                this.$emit('submit')
			},
			
            onChange() {
                this.$emit('select-all')
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
